const UserRole = {
  Admin: 'admin',
  Candidate: 'Candidate',
  CompanyMember: 'CompanyMember',
}

Object.freeze(UserRole)

export { UserRole }

const CandidateState = {
  Onboarding: 'onboarding',
  PreReview: 'pre_review',
  TechnicalScreening: 'technical_screening',
  InReview: 'in_review',
  Accepted: 'accepted',
  ReadyToGoLive: 'ready_to_go_live',
  ReadyForEvent: 'ready_for_event',
  Live: 'live',
  PostLive: 'post_live',
  PostEvent: 'post_event',
}

Object.freeze(CandidateState)

export { CandidateState }
